import { Form } from 'antd';
import React, { FC, lazy, Suspense } from 'react';

import ByModal from '@/components/ByModal';
import { useI18nContext } from '@/i18n/I18n';

import { useStore } from './store/captchaProvider';

const InputForSafetyComp = lazy(async () => {
  const { InputForSafety } = await import('@/components/VerifyComp');
  return { default: InputForSafety };
});

interface IProps {
  visible: boolean;
  setVisible: React.Dispatch<React.SetStateAction<boolean>>;
  onVerifyAccount: (t?: string) => void;
  setBizToken: React.Dispatch<React.SetStateAction<string>>;
}
const Google2faModal: FC<IProps> = ({
  visible,
  setVisible,
  onVerifyAccount,
  setBizToken,
}) => {
  const [$t, lang] = useI18nContext();
  const [form] = Form.useForm();
  const { $tFn } = useStore();
  const handleCancel = () => {
    form.setFieldValue('verifyCode', null);
    setVisible(false);
    setBizToken('');
  };

  const onInputChange = (value: string) => {
    if (value.length === 6) {
      setVisible(false);
      onVerifyAccount(value);
    }
  };

  return (
    <>
      <ByModal
        title={$t('child.securityVerification')}
        visible={visible}
        width={480}
        onCancel={handleCancel}
      >
        <div>
          <Form form={form} className="sub-account-login-2fa-modal">
            <Form.Item name="verifyCode">
              <Suspense>
                <InputForSafetyComp
                  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                  //  @ts-ignore
                  type="mini"
                  lang={lang}
                  $t={$tFn}
                  isRoot={true}
                  verify={[{ component_id: 'google2fa' }]}
                  hiddenUnBindGoogleText={true}
                  onInputChange={onInputChange}
                  // onGoogleTips={onGoogleTips}
                />
              </Suspense>
            </Form.Item>
          </Form>
        </div>
      </ByModal>
    </>
  );
};
export default Google2faModal;
